/* eslint-disable consistent-return */
import React from 'react';

const handleClick = (e, href, onAnchorClick) => {
  if (typeof onAnchorClick !== 'function') return;

  e.preventDefault();
  onAnchorClick(href);
};

const anchorTransform = (node, onAnchorClick) => {
  if (node?.name === 'a' && node?.type === 'tag') {
    const { href } = node?.attribs || {};

    return (
      <a
        href={href}
        key={`${href} + ${Math.random()}`}
        onClick={e => handleClick(e, href, onAnchorClick)}
      >
        {node?.children?.[0]?.data}
      </a>
    );
  }
};

export default anchorTransform;
